export const QUESTIONS = [
  {
    id: "mood",
    titleKey: "q_mood",
    options: [
      { labelKey: "mood_light_refreshing", value: "light_refreshing" },
      { labelKey: "mood_fruity_juicy", value: "fruity_juicy" },
      { labelKey: "mood_hoppy_rich", value: "hoppy_rich" },
      { labelKey: "mood_dark_deep", value: "dark_deep" },
      { labelKey: "mood_sour_unusual", value: "sour_unusual" },
      { labelKey: "mood_unknown", value: "unknown" },
    ],
  },
  {
    id: "intensity",
    titleKey: "q_intensity",
    options: [
      { labelKey: "intensity_low", value: "low" },
      { labelKey: "intensity_medium", value: "medium" },
      { labelKey: "intensity_high", value: "high" },
      { labelKey: "intensity_very_high", value: "very_high" },
    ],
  },
  {
    id: "taste",
    titleKey: "q_taste",
    options: [
      { labelKey: "taste_clean_fresh", value: "clean_fresh" },
      { labelKey: "taste_fruity", value: "fruity" },
      { labelKey: "taste_bitter", value: "bitter" },
      { labelKey: "taste_malty", value: "malty" },
      { labelKey: "taste_sour", value: "sour" },
      { labelKey: "taste_roasted", value: "roasted" },
    ],
  },
  {
    id: "bitterness",
    titleKey: "q_bitterness",
    options: [
      { labelKey: "bitterness_low", value: "low" },
      { labelKey: "bitterness_medium", value: "medium" },
      { labelKey: "bitterness_high", value: "high" },
      { labelKey: "bitterness_very_high", value: "very_high" },
    ],
  },
  {
    id: "experimental",
    titleKey: "q_experimental",
    options: [
      { labelKey: "experimental_safe", value: "safe" },
      { labelKey: "experimental_medium", value: "medium" },
      { labelKey: "experimental_interesting", value: "interesting" },
      { labelKey: "experimental_wild", value: "wild" },
    ],
  },
];